// removed by extract-text-webpack-plugin
module.exports = {"instructions":"instructions__instructions--ac45874d"};


//////////////////
// WEBPACK FOOTER
// ./src/scss/ui/instructions.scss
// module id = 351
// module chunks = 0